import { Injectable } from '@angular/core';
import { EnvironmentService } from '@lib/core/environment';
import { Label } from '@lib/label';
import { AuthHttpClient } from '@proget-shared/auth-http-client';
import { map, Observable } from 'rxjs';

import { UserEntraId } from './model/user-entra-id';
import { UserLdap } from './model/user-ldap';
import { User } from './model/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserRepository {
  constructor(private httpClient: AuthHttpClient, private environment: EnvironmentService) {}

  public getLoggedUser(persistRequest = false): Observable<User> {
    return this.httpClient
      .get(
        `${this.environment.apiUrl}/me`, // changed to /me endpoint because of permissions collision for getting /user/${uuid}
        { params: { persist: persistRequest.toString() } }
      )
      .pipe(
        map((userData: any) => (userData
          ? new User(
            userData.id,
            userData.firstName,
            userData.lastName,
            userData.username,
            userData.email,
            userData.phoneNumber,
            userData.vip,
            userData.createdAt,
            userData.account,
            userData.activationExpiresAt,
            userData.superAdmin,
            userData.type,
            userData.ldap ? new UserLdap(userData.ldap.id, userData.ldap.name) : null,
            userData.azure ? new UserEntraId(userData.azure.id, userData.azure.name) : null,
            userData.labels ? userData.labels.map(({ id, name, color }) => new Label(id, name, color)) : []
          )
          : null)
        )
      );
  }
}
